module.exports = __webpack_public_path__ + "static/media/plataforma-img2.4ec1fdb5.jpg";